var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_491_4276",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.568359 0H31.5684V31H0.568359V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_491_4276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.217 5.87305H3.90252C3.26026 5.87346 2.64446 6.12888 2.19046 6.58317C1.73646 7.03746 1.48145 7.65344 1.48145 8.2957V27.6707C1.48145 28.3132 1.73669 28.9294 2.19103 29.3838C2.64536 29.8381 3.26155 30.0933 3.90408 30.0933H23.2791C23.5972 30.0936 23.9121 30.0311 24.2061 29.9095C24.5 29.7879 24.7671 29.6096 24.992 29.3848C25.217 29.1599 25.3955 28.893 25.5173 28.5991C25.639 28.3053 25.7017 27.9903 25.7017 27.6722V14.35",
    stroke: "#2179FE",
    strokeWidth: 1.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3058 4.68284L16.6053 18.3833L12.3242 19.2389L13.1798 14.9578L26.8803 1.25734C27.107 1.03244 27.4134 0.90625 27.7328 0.90625C28.0521 0.90625 28.3585 1.03244 28.5853 1.25734L30.2903 2.96234C30.405 3.07387 30.4964 3.20705 30.5594 3.35415C30.6223 3.50126 30.6555 3.65937 30.6569 3.81936C30.6584 3.97935 30.6281 4.13804 30.5678 4.28626C30.5075 4.43447 30.4185 4.56925 30.3058 4.68284Z",
    stroke: "#2179FE",
    strokeWidth: 1.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.168 2.97461L28.5935 6.40011",
    stroke: "#2179FE",
    strokeWidth: 1.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1f5013c603ab9361930ddbabd931034a.svg";
export { ForwardRef as ReactComponent };